/**
 * Supported tume units.
 * NOTE: do not change freely, must match the values in db
 */
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["sec"] = "sec";
    TimeUnit["min"] = "min";
    TimeUnit["hour"] = "hour";
    TimeUnit["day"] = "day";
    TimeUnit["week"] = "week";
    TimeUnit["month"] = "month";
    TimeUnit["year"] = "year";
})(TimeUnit || (TimeUnit = {}));
//# sourceMappingURL=time-unit.js.map